<app-ui-button nz-dropdown nzTrigger="click" nzDisabled class="disabled" [size]="'small'" [theme]="'select'" [disabled]="true" [nzDropdownMenu]="menu4">
  {{ label }}
  <app-ui-icon [iconName]="'icon-down'"></app-ui-icon>
</app-ui-button>

<nz-dropdown-menu #menu4="nzDropdownMenu">
</nz-dropdown-menu>
